/** @jsx jsx */
import { jsx } from '@emotion/react';

import { useParams } from 'js/lib/useRouter';

import { useTracker } from '@coursera/event-pulse/react';

import { redirectClientOrServer } from 'bundles/common/utils/urlUtils';
import OnboardingResultsHeaderModule from 'bundles/page-config-common/components/shared/OnboardingResultsHeaderModule';
import { useEnterpriseOnboardingData } from 'bundles/page-config-common/contexts/enterprise/EnterpriseOnboardingContext';

// Required for styles within FrontDesk
// eslint-disable-next-line no-restricted-syntax
import 'css!bundles/coursera-ui/styles/css/utilities';

const OnboardingResultsHeaderModuleRenderer = () => {
  const { programSlug } = useParams();
  const { enterpriseOnboardingDataLoading, enterpriseLearningGoalMessage, enterpriseCompletedOnboarding } =
    useEnterpriseOnboardingData();
  const track = useTracker();

  return (
    <OnboardingResultsHeaderModule
      loading={enterpriseOnboardingDataLoading}
      message={enterpriseLearningGoalMessage}
      hasCompletedOnboarding={enterpriseCompletedOnboarding}
      onEditButtonClick={() => {
        track('click_button', { button: { name: 'onboarding_edit' } });
        redirectClientOrServer(`/programs/${programSlug}/onboarding`);
      }}
    />
  );
};

export default OnboardingResultsHeaderModuleRenderer;
